// Class: starling.filters.FilterQuad

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_display_Mesh() {return require("./../../starling/display/Mesh");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_Error() {return $import(require("openfl/errors/Error"));}
function openfl_geom_Matrix() {return $import(require("openfl/geom/Matrix"));}
function starling_rendering_VertexData() {return require("./../../starling/rendering/VertexData");}
function starling_rendering_IndexData() {return require("./../../starling/rendering/IndexData");}

// Constructor

var FilterQuad = function(smoothing) {
	var vertexData = new (starling_rendering_VertexData().default)(null,4);
	vertexData.set_numVertices(4);
	var indexData = new (starling_rendering_IndexData().default)(6);
	indexData.addQuad(0,1,2,3);
	(starling_display_Mesh().default).call(this,vertexData,indexData);
	this.set_textureSmoothing(smoothing);
	this.set_pixelSnapping(false);
}

// Meta

FilterQuad.__name__ = ["starling","filters","FilterQuad"];
FilterQuad.__super__ = (starling_display_Mesh().default);
FilterQuad.prototype = $extend((starling_display_Mesh().default).prototype, {
	dispose: function() {
		this.disposeTexture();
		(starling_display_Mesh().default).prototype.dispose.call(this);
	},
	disposeTexture: function() {
		if(this.get_texture() != null) {
			this.get_texture().dispose();
			this.set_texture(null);
		}
	},
	moveVertices: function(sourceSpace,targetSpace) {
		if(targetSpace.get_is3D()) {
			throw new (js__$Boot_HaxeError().default)(new (openfl_errors_Error().default)("cannot move vertices into 3D space"));
		} else if(sourceSpace != targetSpace) {
			targetSpace.getTransformationMatrix(sourceSpace,FilterQuad.sMatrix).invert();
			this.get_vertexData().transformPoints("position",FilterQuad.sMatrix);
		}
	},
	setBounds: function(bounds) {
		var vertexData = this.get_vertexData();
		var attrName = "position";
		vertexData.setPoint(0,attrName,bounds.x,bounds.y);
		vertexData.setPoint(1,attrName,bounds.get_right(),bounds.y);
		vertexData.setPoint(2,attrName,bounds.x,bounds.get_bottom());
		vertexData.setPoint(3,attrName,bounds.get_right(),bounds.get_bottom());
	},
	set_texture: function(value) {
		(starling_display_Mesh().default).prototype.set_texture.call(this,value);
		if(value != null) {
			value.setupTextureCoordinates(this.get_vertexData());
		}
		return value;
	}
});
FilterQuad.prototype.__class__ = FilterQuad.prototype.constructor = $hxClasses["starling.filters.FilterQuad"] = FilterQuad;

// Init



// Statics


FilterQuad.sMatrix = new (openfl_geom_Matrix().default)()

// Export

exports.default = FilterQuad;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/FilterQuad.js
// module id = 316
// module chunks = 0